import { cardActionAreaClasses } from '@mui/material'
import { type ComponentsOverrides, type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { highContrast } from '@Styles/a11y'
import { RADIUS_1, RADIUS_2 } from '@Styles/constants/radius'
import { getRawFocusVisibleStyle } from '@Styles/focus'
import { getInnerBorderRadius } from '@Utils/border'

const FOCUS_OFFSET = rem(2)

export const overridesCard = (): ComponentsOverrides['MuiCard'] => ({
  root: {
    boxShadow: 'none',
    border: 'none',
  },
})

export const overridesCardContent = (theme: Theme): ComponentsOverrides['MuiCardContent'] => ({
  root: {
    padding: theme.spacing(2),

    // overrides the padding added to the last child by MUI
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
})

export const overridesCardActionArea = (theme: Theme): ComponentsOverrides['MuiCardActionArea'] => ({
  focusHighlight: {
    display: 'none',
  },
  root: {
    ...highContrast({
      border: 'solid 2px transparent',
      borderRadius: RADIUS_2,
    }),
    [`&.${cardActionAreaClasses.focusVisible}`]: {
      /**
       * First child has radius on top borders
       */
      '&:first-of-type::before': {
        borderTopLeftRadius: getInnerBorderRadius(RADIUS_1, FOCUS_OFFSET),
        borderTopRightRadius: getInnerBorderRadius(RADIUS_1, FOCUS_OFFSET),
      },
      /**
       * Default has no radius
       */
      '&::before': getRawFocusVisibleStyle(theme.palette.primary.main, '0'),
      /**
       * Last child has radius on bottom borders
       */
      '&:last-child::before': {
        borderBottomLeftRadius: getInnerBorderRadius(RADIUS_1, FOCUS_OFFSET),
        borderBottomRightRadius: getInnerBorderRadius(RADIUS_1, FOCUS_OFFSET),
      },
    },
    '&:hover': {
      backgroundColor: theme.customPalette.onElements.selected,
      ...highContrast({
        backgroundColor: 'HighLight',
      }),
    },
  },
})
